import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';

import Grants from 'components/BKanatarciResearchGrants/Grants';


function ResearchGrants() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  return (
    <>
    {isMobile ? ( 
      <>
        <MobileNavbar /> 
        <Grants/>
        <hr />
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <Grants/>
        <hr />
        <Footer />
      </>
    )}
    </>
  );
}

export default ResearchGrants;
